<script lang="ts" setup>
import { useBasketStore } from '~/store/basket/basket'

const basketStore = useBasketStore()

const doNotCallMeBack = computed(() => {
  return basketStore.data.doNotCallMeBack
})

const changeDoNotCallMeBack = (value: unknown) => {
  basketStore.setDoNotCallMeBack(value as boolean)
}
</script>

<template>
  <div class="call">
    <div class="call__top-container">
      <div class="call__title">Подтверждать заказ звонком</div>

      <!-- Отрицание значений, т.к. на бэке true - это не звонить -->
      <v-switch
        class="call__switch"
        :model-value="doNotCallMeBack"
        :ripple="false"
        :true-value="false"
        :false-value="true"
        inset
        hide-details
        @update:model-value="changeDoNotCallMeBack"
      />
    </div>

    <div class="call__description">
      Больше не нужно ждать звонка. Отключите подтверждение заказа звонком и мы
      сразу примем ваш заказ
    </div>
  </div>
</template>

<style scoped lang="scss">
.call {
  &__top-container {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  &__title {
    font-size: 18px;
    font-weight: 800;
    color: $text-black;

    @include media('<=tablet') {
      font-size: 14px;
    }
  }

  &__switch {
    flex: 0 1 auto;
    padding: 0;
    margin: 0;
  }

  &__description {
    width: 100%;
    max-width: 414px;
    font-size: 14px;
    font-weight: 600;
    color: $dark-grey;

    @include media('<tablet') {
      max-width: unset;
    }
  }

  /* v-switch custom */
  :deep() {
    /* Контейнер с треком и кругом */
    .v-selection-control {
      height: 32px;
      min-height: unset;
    }

    .v-switch__track {
      width: 56px;
      height: 32px;
      margin: 0;
      background-color: $very-light-grey;
      opacity: 1;
    }

    .v-selection-control__input {
      width: 26px;
      height: 26px;
      background-color: white;
      box-shadow: 0 2px 5px -3px black;

      &:before {
        content: none;
      }
    }

    /* Активный */
    .v-selection-control--dirty {
      .v-switch__track {
        background-color: $primary !important;
      }

      .v-selection-control__input {
        box-shadow: none;
      }
    }
  }
}
</style>
